<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.ADMIN.ANSWER.MANAGE') }}</i>
                    </dt>
                    <dd>
                        <div class="Select_wrap">
                            <ul class="txt_sel">
                                <li class="tit">{{ $t('TITLE.GLOBAL.ANSWERERS') }}</li>
                                <li data-input-type="select" class="sel">
                                    <fieldset class="serachbtn_wrap">
                                        <label class="serach-wrap">
                                            <input type="text" v-model="loginNm" class="text_input" disabled />
                                            <a href="javascript:" class="in_btn_search" @click="searchUserPop()">
                                                <i class="ico_input_serach"></i><span class="sr_only"></span>
                                            </a>
                                        </label>
                                        <a href="javascript:" class="btn_white" @click="resetClick()">
                                            {{ $t('BUTTON.GLOBAL.RESET') }}
                                        </a>
                                    </fieldset>
                                </li>
                            </ul>
                        </div>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="grid_wrap mt10">
                            <div class="btn_wrap">
                                <a href="javascript:" class="btn_blue" @click="onSave()">
                                    {{ $t('BUTTON.GLOBAL.UPDATE') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';

import searchUserPop from '~va/qnaManager/popup/searchUserPop';

export default {
    name: 'europeChangePop',
    props: {
        rhqCode: '',
        searchSubsidiary: '',
        searchCategoryA: '',
        searchCategoryB: '',
        searchCategoryC: '',
        searchInquiryType1: '',
        searchInquiryType2: '',
        targetUser: '',
        targetUserNm: '',
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'europeChangePop',
            loginId: '',
            loginNo: '',
            loginNm: '',
        };
    },
    methods: {
        onSave() {
            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.MODIFY.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/answererUpdateEU.skp`,
                            qs.stringify({
                                rhqCode: this.rhqCode,
                                searchSubsidiary: this.searchSubsidiary,
                                searchCategoryA: this.searchCategoryA,
                                searchCategoryB: this.searchCategoryB,
                                searchCategoryC: this.searchCategoryC,
                                searchInquiryType1: this.searchInquiryType1,
                                searchInquiryType2: this.searchInquiryType2,
                                targetUser: this.targetUser,
                                targetUserNm: this.targetUserNm,
                                searchAnswererId: this.loginId,
                                searchAnswererNo: this.loginNo,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            let msg = resp.data.msg;
                            SDLUtil.alert(msg);
                            if (msg.indexOf('successfully') > -1) {
                                this.rtnFunc();
                                this.$emit('close');
                            }
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        searchUserPop() {
            SDLUtil.show(
                searchUserPop,
                {
                    rtnFunc: (arg1, arg2, arg3) => {
                        this.loginNo = arg1;
                        this.loginId = arg2;
                        this.loginNm = arg3;
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        resetClick() {
            this.loginNo = '';
            this.loginId = '';
            this.loginNm = '';
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/popup/europeChangePop.vue